<template>
  <div class="home-box">
    <template v-for="(section, index) in list">
      <NvSection :section="section" :key="index" />
      <p :key="'p' + index" v-if="index === 2" ref="adBox1" class="ad-box"></p>
      <p :key="'p' + index" v-if="index === 3" ref="adBox2" class="ad-box"></p>
    </template>
    <!-- <div v-if="lastReadBook && showModal" class="continue-modal">
      <NvContinueModal :book="lastReadBook" />
    </div> -->
    <img class="banner" :src="bannerImage" alt="novelover banner" />
  </div>
</template>

<script>
import NvSection from "@/components/layout/NvSection";
// import NvContinueModal from "@/components/NvContinueModal";
import { getBookList, getLastRead } from "@/service/api";
import bannerImage from "@/assets/banner_logo.png";
import { appendAdUnit } from "@/service/utils";

const MODAL_DURATION = 5000;

export default {
  name: "NvDiscover",
  components: {
    NvSection
    // NvContinueModal
  },
  data() {
    return {
      show: false,
      list: [],
      bannerImage,
      lastReadBook: null
    };
  },
  computed: {
    showModal() {
      return this.$store.state.showContinueBtn;
    }
  },
  methods: {
    getList() {
      getBookList().then(res => {
        this.list = res || [];
        this.displayAds();
      });
    },
    getLastReadRecord() {
      getLastRead().then(res => {
        this.lastReadBook = res;
      });
    },
    hideModalTimer() {
      this.$store.commit("HIDE_CONTINUE_BTN");
    },
    displayAds() {
      this.$nextTick(() => {
        const mountPoint = this.$refs.adBox1;
        mountPoint &&
          mountPoint[0] &&
          appendAdUnit(
            mountPoint[0],
            {
              reponsive: true,
              style: "display:block; width: 100vw",
              format: "auto",
              slot: "4419974009",
              client: "ca-pub-2892562339706817"
            },
            true
          );
      });
      this.$nextTick(() => {
        const mountPoint = this.$refs.adBox2;
        mountPoint &&
          mountPoint[0] &&
          appendAdUnit(
            mountPoint[0],
            {
              reponsive: true,
              style: "display:block; width: 100vw",
              format: "auto",
              slot: "7700483708",
              client: "ca-pub-2892562339706817"
            },
            true
          );
      });
    }
  },
  mounted() {
    // this.getLastReadRecord();
    this.timer = setTimeout(() => {
      this.hideModalTimer();
    }, MODAL_DURATION);
  },
  activated() {
    this.getList();
    window.$event("Main_BookCity_Show", {});
  },
  deactivated() {
    this.$store.commit("HIDE_CONTINUE_BTN");
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
};
</script>

<style lang="scss" scoped>
.home-box {
  .banner {
    width: 100%;
    height: 70px;
    margin-bottom: 50px;
  }
  .continue-modal {
    padding: 1rem;
    position: fixed;
    bottom: 50px;
    width: calc(100vw - 2rem);
  }
}
</style>
